<template>
  <div>
    <Create :createDialog="createDialog" @close="close" @created="created" :createFromStore="false">
    </Create>
    <Edit
      :editDialog="editDialog"
      @close="closeEdit"
      @updated="updated"
      :editFromStore="false"
      :task="selectedTask"
    >
    </Edit>
    <v-container grid-list-lg fluid>
      <v-layout column>
        <v-flex>
          <v-card>
            <v-toolbar class="elevation-0" height="45" color="gray">
              <v-toolbar-title>
                <h1 class="subheading">{{ $t("labels.filters") }}</h1>
              </v-toolbar-title>
              <v-spacer> </v-spacer>
              <v-tooltip class="ml-1 pointer" bottom="bottom">
                <template slot="activator">
                  <v-btn flat="flat" @click="reset" icon="icon">
                    <v-icon>autorenew</v-icon>
                  </v-btn>
                </template>
                <span>Reset</span>
              </v-tooltip>
              <v-tooltip class="ml-1 pointer" bottom="bottom">
                <template slot="activator">
                  <v-btn flat="flat" @click="reloadData" icon="icon">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </template>
                <span>Fetch Data</span>
              </v-tooltip>
            </v-toolbar>

            <v-card-text>
              <VueCtkDateTimePicker
                v-model="setDueDate"
                noClearButton
                label="Select Due Date Range"
                range
                @input="setDueDateTime"
                overlay
              ></VueCtkDateTimePicker>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex>
          <v-card class="mt2">
            <v-toolbar class="elevation-0" height="45" color="gray">
              <v-toolbar-title>
                <h1 class="subheading">{{ $t("pageHeader.tasks") }}</h1>
              </v-toolbar-title>
              <v-btn color="teal" dark small absolute bottom right fab @click="add">
                <v-icon>add</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
                clearable
              >
              </v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="task"
              :search="search"
              :loading="loading"
              :pagination.sync="pagination"
            >
              <template slot="items" slot-scope="props">
                <tr class="pointer">
                  <td class="text-xs-left">
                    <span>{{ $moment(props.item.createdAt).format("MM/DD/YYYY") }}</span>
                    <v-chip v-model="props.item.isComplete" small color="green" text-color="white"
                      >Complete</v-chip
                    >
                  </td>
                  <td class="text-xs-left" v-html="$options.filters.highlight(props.item.assignedToUser.fullName, search)">{{ props.item.assignedToUser.fullName }}</td>
                  <td class="text-xs-left" v-html="$options.filters.highlight(props.item.title, search)">{{ props.item.title }}</td>
                  <td class="text-xs-left" v-html="$options.filters.highlight(props.item.reporterUser.fullName, search)">{{ props.item.reporterUser.fullName }}</td>
                  <td class="text-xs-left">
                    <template v-if="props.item.taskPriorityDetail" v-html="$options.filters.highlight(props.item.taskPriorityDetail.selector, search)">
                      <p>{{ props.item.taskPriorityDetail.selector }}</p>
                    </template>
                  </td>
                  <td class="justify-end layout px-0">
                    <v-menu bottom left="left" offset-y="offset-y">
                      <v-btn slot="activator" icon>
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                      <v-list class="menu-button">
                        <v-list-tile
                          @click="$router.push({ path: `/task/profile/${props.item.id}` })"
                        >
                          <v-list-tile-title>Profile</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="editTask(props.item)">
                          <v-list-tile-title>{{ $t("buttons.edit") }}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile
                          v-if="currentUser.accountTypeID == 1"
                          @click="deleteTask(props.item)"
                        >
                          <v-list-tile-title>{{ $t("buttons.delete") }}</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
              </template>

              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
              </v-alert>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { TASK } from "../../../../helper/Constant";
import { mapGetters } from "vuex";
const Create = () => import("./Create");
const Edit = () => import("./Edit");
import taskService from "../service.js";
import userService from "../../User/service.js";
import locationService from "../../Location/service.js";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";

export default {
  props: ["location"],
  components: {
    Create,
    Edit,
    VueCtkDateTimePicker
  },
  data() {
    return {
      proFilter: {
        assignedToMe: false,
        reporteredByMe: false,
        fromDate: null,
        toDate: null,
        fromDueDate: null,
        toDueDate: null
      },
      setDate: {
        start: null,
        end: null
      },
      filter: {
        software: [],
        reporterUser: [],
        status: [],
        assignedToUser: [],
        taskPriority: [],
        store: [],
        fromDate: null,
        toDate: null
      },
      setDueDate: {
        start: null,
        end: null
      },
      dueDatefilter: {
        fromDueDate: null,
        toDueDate: null
      },
      createDialog: false,
      editDialog: false,
      headers: [
        {
          text: this.$t("labels.createdAt"),
          value: "createdAt",
          sortable: true,
          align: "left"
        },
        {
          text: this.$t("labels.assignedTo"),
          value: "assignedToUser.fullName",
          align: "left",
          sortable: true
        },
        {
          text: this.$t("labels.title"),
          value: "title",
          align: "left",
          sortable: true
        },
        {
          text: "Added by",
          value: "reporterUser.fullName",
          align: "left",
          sortable: true
        },
        {
          text: this.$t("labels.priority"),
          value: "taskPriorityDetail.id",
          align: "left",
          sortable: true
        },
        {
          text: "",
          value: "action",
          sortable: false
        }
      ],
      search: null,
      refundDialog: false,
      selectedTask: null,
      task: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "createdAt",
        descending: true
      }
    };
  },
  activated() {
    this.getList();
  },
  async created() {
    this.getList();
    // this.reset();
  },
  computed: {
    ...mapGetters("global", ["comboBox", "comboBoxByID"]),
    ...mapGetters("global", ["currentUser"]),
    titleErrors() {
      const errors = [];
      if (!this.$v.Task.title.$dirty) return errors;
      if (!this.$v.Task.title.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Task.title.minLength) errors.push("Field must be at least 10 characters long");
      return errors;
    }
  },
  methods: {
    resetDueDateDateTime() {
      this.setDueDate.start = null;
      this.setDueDate.end = null;
      this.dueDatefilter.fromDueDate = null;
      this.dueDatefilter.toDueDate = null;
      this.proFilter.fromDueDate = null;
      this.proFilter.toDueDate = null;
    },
    editTask(data) {
      this.selectedTask = data;
      this.editDialog = !this.editDialog;
    },
    save() {
      this.getList();
    },
    add() {
      this.createDialog = true;
    },
    closeEdit() {
      this.editDialog = false;
    },
    close() {
      this.createDialog = false;
    },
    created() {
      this.close();
      this.reset();
      // this.getList()
    },
    updated() {
      this.closeEdit();
      this.reset();
    },
    edit(data) {
      this.selectedTask = data;
      this.editDialog = true;
    },
    getAllTask(proFilter) {
      if (this.currentUser.accountTypeID !== 1 && this.currentUser.accountTypeID !== 2) {
        proFilter["myTask"] = true;
      }
      console.log("this.profilter is :", proFilter);
      return taskService
        .getAll(proFilter)
        .then(response => {
          this.task = response.data;
          this.loading = false;
          return response;
        })
        .catch(error => {
          throw error;
        });
    },
    getList() {
      this.resetProFilter();
      //due Date
      if (this.dueDatefilter.fromDueDate)
        this.proFilter.fromDueDate = this.$moment(this.dueDatefilter.fromDueDate).format(
          "MM/DD/YYYY h:m a"
        );
      if (this.dueDatefilter.toDueDate)
        this.proFilter.toDueDate = this.$moment(this.dueDatefilter.toDueDate).format(
          "MM/DD/YYYY h:m a"
        );
      this.loading = true;
      this.getAllTask(this.proFilter);
    },
    deleteTask(task) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          taskService
            .delete(task.id)
            .then(response => {
              if (response.data) {
                this.$swal("Deleted!", "Task has been deleted.", "success");
                this.getList();
              }
            })
            .catch(error => {
              throw error;
            });
        }
      });
    },
    async reset() {
      await this.resetProFilter();
      this.resetFilter();
      await this.getAllTask();
    },
    reloadData() {
      this.loading = true;
      this.Task = [];
      this.getList();
    },
    resetFilter() {
      (this.filter.software = []),
        (this.filter.reporterUser = []),
        (this.filter.status = []),
        (this.filter.assignedToUser = []),
        (this.filter.taskPriority = []),
        (this.filter.store = []),
        (this.filter.fromDate = null);
      this.filter.assignedToUser = [];
      this.filter.toDate = null;
      this.dueDatefilter.toDueDate = null;
      this.dueDatefilter.fromDueDate = null;
      this.setDateTime.start = null;
      this.setDateTime.end = null;
      this.setDueDateTime.start = null;
      this.setDueDateTime.end = null;
    },
    resetProFilter() {
      this.proFilter = {
        fromDueDate: null,
        toDueDate: null,
        store: []
      };

      return true;
    },
    setDateTime(val) {
      if (val) {
        if (val.start) this.filter.fromDate = val.start;
        if (val.end) this.filter.toDate = val.end;
        this.getList();
      }
    },
    setDueDateTime(val) {
      if (val) {
        if (val.start) this.dueDatefilter.fromDueDate = val.start;
        if (val.end) this.dueDatefilter.toDueDate = val.end;
        this.getList();
      }
    }
  }
};
</script>

<style scoped></style>
